import React, { Component } from 'react';
import { valuesToHtmlString } from './helpers/iframeHelpers';

class Iframe extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.envelope) { this._renderIframe(nextProps.envelope); }
  }
  componentDidMount() {
    if (this.props.envelope) { this._renderIframe(this.props.envelope); }
  }



  // allow-forms: Allows the embedded browsing context to submit forms. If this keyword is not used, this operation is not allowed.
  // allow-modals: Allows the embedded browsing context to open modal windows.
  // allow-orientation-lock: Allows the embedded browsing context to disable the ability to lock the screen orientation.
  // allow-pointer-lock: Allows the embedded browsing context to use the Pointer Lock API.
  // allow-popups: Allows popups (like from window.open, target="_blank", showModalDialog). If this keyword is not used, that functionality will silently fail.
  // allow-popups-to-escape-sandbox:  Allows a sandboxed document to open new windows without forcing the sandboxing flags upon them. This will allow, for example, a third-party advertisement to be safely sandboxed without forcing the same restrictions upon a landing page.
  // allow-presentation: Allows embedders to have control over whether an iframe can start a presentation session.
  // allow-same-origin: Allows the content to be treated as being from its normal origin. If this keyword is not used, the embedded content is treated as being from a unique origin.
  // allow-scripts: Allows the embedded browsing context to run scripts (but not create pop-up windows). If this keyword is not used, this operation is not allowed.
  // allow-top-navigation: Allows the embedded browsing context to navigate (load) content to the top-level browsing context. If this keyword is not used, this operation is not allowed.
  // allow-top-navigation-by-user-activation: Allows the embedded browsing context to navigate (load) content to the top-level browsing context only when initiated by a user gesture. If this keyword is not used, this operation is not allowed.

  render() {
    return (
      <iframe
        // NAY:
        // allow-forms
        // allow-modals
        // allow-pointer-lock
        // allow-popups
        // allow-popups-to-escape-sandbox
        // allow-top-navigation
        // allow-top-navigation-by-user-activation
        // allow-presentation
        // allow-orientation-lock
        //
        // YAY:
        // allow-orientation-lock
        // allow-presentation
        // allow-scripts
        // allow-same-origin

        sandbox="allow-same-origin allow-scripts"
        style={this.props.styleProps}
        ref="iframe"
      />
    )
  }
  _renderIframe = (envelope) => {
    // this.refs.iframe.src = "about:blank";
    var doc = this.refs.iframe.contentDocument;
    doc.open();
    doc.write(valuesToHtmlString(envelope));
    doc.close();
  }
}

export default Iframe;



// WEBPACK FOOTER //
// ./src/_NewIframe.js